import * as route from "../routes/constants";
import LiveSubMenuItems from "./liveSubMenuItems";
import FixtureMenuItems from "./fixtureSubMenuItems";
import { metatags } from "../config/meta-tags";
/*import MultipleScreensMenuItems from "./multipleScreensSubMenuItems";*/

const menuItems = [
    {
        label: "Canlı Bahisler",
        key: metatags.live.slug,
        path: route.LIVE_FOOTBALL,
        children: LiveSubMenuItems,
        translateKey: "live"
    },
    {
        label: "Yaklaşan Maçlar",
        key: metatags.fixture.slug,
        path: route.FIXTURE_FOOTBALL,
        children: FixtureMenuItems,
        translateKey: "fixture"
    },
    /*{
        label: "Tekli-Çoklu",
        key: metatags.multipleScreens.slug,
        path: route.MULTIPLE_SCREENS,
        children: MultipleScreensMenuItems,
        translateKey: "multipleScreens"
    },*/
    {
        label: "Canlı Sonuçlar",
        key: metatags.liveResults.slug,
        path: route.LIVE_RESULTS,
        translateKey: "liveResults"
    },
    {
        label: "Maç Sonuçları",
        key: metatags.matchDetail.slug,
        path: route.MATCH_RESULTS,
        translateKey: "matchResults"
    },
    {
        label: "Keno",
        key: metatags.keno.slug,
        path: route.KENO,
        translateKey: "keno"
    },

];

export default menuItems;
